import React from 'react';
import { Box, Typography, Card, CardMedia, CardContent, Button, Chip, Menu, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, RadioGroup, FormControlLabel, Radio, FormControl } from '@mui/material';
import { ShoppingCart } from '@mui/icons-material';
// @ts-ignore
import { Resizable } from 're-resizable';
import ElementStyleEditorModal from './ElementStyleEditorModal';

// Tipler
type ImageNavigationStyle = 'numbered' | 'circle' | 'dot';

// BİLEŞEN DIŞINDAN ÜRÜN BİLGİSİ ALMAK İÇİN YENİ TİP
export interface PreviewableProduct {
  id: string;
  name: string;
  imageUrl?: string | null;
  imageUrls?: (string | null)[];
  stockCode?: string;
  salePrice?: number;
  saleCurrency?: string;
  quantity?: number;
}

// Varsayılan/Örnek Ürün
const mockProduct: PreviewableProduct = {
  id: 'mock-1',
  name: 'Örnek Ürün Adı',
  imageUrl: '/assets/gtslogo.jpg',
  imageUrls: [
    '/assets/gtslogo.jpg',
    '/assets/anket_yonetimi.png',
    '/assets/bildirim_ekran.png',
    '/assets/genel_gorev_ekran.png'
  ],
  stockCode: 'SKU12345',
  salePrice: 199.99,
  saleCurrency: 'TL',
  quantity: 3,
};

interface InteractiveProductCardPreviewProps {
  cardSize: { width: number, height: number };
  setCardSize: (size: { width: number, height: number }) => void;
  imageHeight: number;
  setImageHeight: (height: number) => void;
  cardSettings: any;
  elementStyles: any;
  setElementStyles: (styles: any) => void;
  imageNavigationStyle: ImageNavigationStyle;
  setImageNavigationStyle: (style: ImageNavigationStyle) => void;
  activeImageIndex: number;
  setActiveImageIndex: (index: number) => void;
  product?: PreviewableProduct | null; // YENİ PROP
  onStyleSave?: (elementKey: string, newStyles: any) => void; // SQL'e kaydetmek için callback
  onSizeChange?: () => void; // Boyut değişikliği için callback
}

const InteractiveProductCardPreview: React.FC<InteractiveProductCardPreviewProps> = (props) => {
  const {
    cardSize, setCardSize, imageHeight, setImageHeight, cardSettings,
    elementStyles, setElementStyles, imageNavigationStyle, setImageNavigationStyle,
    activeImageIndex, setActiveImageIndex,
    product,
    onStyleSave,
    onSizeChange
  } = props;
  
  const displayProduct = product || mockProduct;
  
  const [contextMenu, setContextMenu] = React.useState<{ mouseX: number; mouseY: number; target: keyof typeof elementStyles; } | null>(null);
  const [imageNavContextMenu, setImageNavContextMenu] = React.useState<{ mouseX: number; mouseY: number; } | null>(null);
  const [isImageNavModalOpen, setIsImageNavModalOpen] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [editingElementKey, setEditingElementKey] = React.useState<keyof typeof elementStyles | null>(null);

  const handleContextMenu = (event: React.MouseEvent, target: keyof typeof elementStyles) => {
    event.preventDefault();
    setContextMenu(contextMenu === null ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4, target } : null);
  };

  const handleCloseContextMenu = () => setContextMenu(null);

  const handleEditClick = () => {
    if (contextMenu) {
      setEditingElementKey(contextMenu.target);
      setIsModalOpen(true);
      handleCloseContextMenu();
    }
  };
  
  const handleStyleSave = (newStyles: any) => {
    console.log('🟢 [PREVIEW] handleStyleSave ÇAĞRILDI!');
    console.log('🟢 [PREVIEW] editingElementKey:', editingElementKey);
    console.log('🟢 [PREVIEW] newStyles:', newStyles);
    
    if (editingElementKey) {
      // Local state'i güncelle
      setElementStyles({ ...elementStyles, [editingElementKey]: newStyles });
      setIsModalOpen(false);
      
      // SQL'e kaydetmek için parent callback'i çağır
      if (onStyleSave) {
        console.log('🟢 [PREVIEW] onStyleSave callback çağrılıyor...');
        onStyleSave(String(editingElementKey), newStyles); // ✅ String'e çevir
      } else {
        console.log('⚠️ [PREVIEW] onStyleSave callback YOK!');
      }
    }
  };

  const handleImageNavContextMenu = (event: React.MouseEvent) => {
    event.preventDefault();
    setImageNavContextMenu(imageNavContextMenu === null ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 } : null);
  };

  const handleCloseImageNavContextMenu = () => setImageNavContextMenu(null);
  
  const handleImageNavEditClick = () => {
    setIsImageNavModalOpen(true);
    handleCloseImageNavContextMenu();
  };
  
  const renderImageNavButtons = () => {
    const allImages = displayProduct.imageUrls || [displayProduct.imageUrl];
    return allImages.map((_, index) => {
      const isActive = index === activeImageIndex;
      switch (imageNavigationStyle) {
        case 'numbered': return <Button key={`nav-num-${index}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setActiveImageIndex(index); }} sx={{ minWidth: '24px', width: '24px', height: '24px', borderRadius: '50%', p: 0, border: '2px solid white', fontSize: '0.75rem', fontWeight: 'bold', bgcolor: isActive ? 'primary.main' : 'rgba(255, 255, 255, 0.8)', color: isActive ? 'white' : 'text.primary', '&:hover': { bgcolor: isActive ? 'primary.dark' : 'white', transform: 'scale(1.1)' } }}>{index + 1}</Button>;
        case 'circle': return <Button key={`nav-circle-${index}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setActiveImageIndex(index); }} sx={{ minWidth: '20px', width: '20px', height: '20px', borderRadius: '50%', p: 0, border: '2px solid white', bgcolor: isActive ? 'primary.main' : 'rgba(255, 255, 255, 0.8)', '&:hover': { bgcolor: isActive ? 'primary.dark' : 'white', transform: 'scale(1.2)' } }} />;
        case 'dot': return <Button key={`nav-dot-${index}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setActiveImageIndex(index); }} sx={{ minWidth: '12px', width: '12px', height: '12px', borderRadius: '50%', p: 0, border: '1px solid white', bgcolor: isActive ? 'primary.main' : 'rgba(255, 255, 255, 0.6)', '&:hover': { bgcolor: isActive ? 'primary.dark' : 'rgba(255, 255, 255, 0.9)', transform: 'scale(1.3)' } }} />;
        default: return null;
      }
    });
  };

  const allImages = displayProduct.imageUrls || [displayProduct.imageUrl];
  const currentImage = allImages[activeImageIndex] || '/assets/gtslogo.jpg';

  return (
    <Box>
      <Resizable
        size={{ width: cardSize.width, height: cardSize.height }}
        onResizeStop={(e, direction, ref, d) => {
          setCardSize({ width: cardSize.width + d.width, height: cardSize.height + d.height });
          // Boyut değişikliğini kaydet
          if (onSizeChange) {
            console.log('📏 [PREVIEW] Kart boyutu değişti, kayıt tetikleniyor...');
            setTimeout(() => onSizeChange(), 100);
          }
        }}
        minWidth={200} minHeight={300} maxWidth={500} maxHeight={700} lockAspectRatio
        handleComponent={{ bottomRight: <div style={{ width: '10px', height: '10px', background: 'rgba(0,0,0,0.5)', position: 'absolute', right: 0, bottom: 0, cursor: 'nwse-resize' }} /> }}
      >
        <Card sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <Box sx={{ overflow: 'hidden', position: 'relative' }}>
            <Resizable
              size={{ width: cardSize.width, height: imageHeight }}
              onResizeStop={(e, direction, ref, d) => {
                setImageHeight(imageHeight + d.height);
                // Resim yüksekliği değişikliğini kaydet
                if (onSizeChange) {
                  console.log('📏 [PREVIEW] Resim yüksekliği değişti, kayıt tetikleniyor...');
                  setTimeout(() => onSizeChange(), 100);
                }
              }}
              minHeight={100} maxHeight={Math.max(300, cardSize.height - 150)}
              enable={{ bottom: true }}
              handleComponent={{ bottom: <div style={{ width: '100%', height: '8px', background: 'rgba(0,0,0,0.3)', position: 'absolute', bottom: 0, left: 0, cursor: 'ns-resize', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', color: 'white' }}>⋯</div> }}
            >
              <CardMedia component="img" image={currentImage} alt={displayProduct.name} sx={{ height: '100%', objectFit: 'cover', width: '100%' }}/>
            </Resizable>
            {(() => {
              const threshold =
                typeof cardSettings?.lowStockThreshold === 'number'
                  ? cardSettings.lowStockThreshold
                  : 5;
              const qty = displayProduct.quantity || 0;
              if (threshold <= 0 || qty <= 0 || qty > threshold) return null;
              return (
                <Typography
                  sx={{
                    position: 'absolute',
                    bottom: 8,
                    left: 8,
                    zIndex: 5,
                    fontSize: '10px',
                    fontWeight: 500,
                    letterSpacing: '0.04em',
                    color: '#fff',
                    textShadow: '0 1px 2px rgba(0,0,0,0.55)',
                    pointerEvents: 'none',
                  }}
                >
                  Tükenmek üzere
                </Typography>
              );
            })()}
            {allImages && allImages.length > 1 && (
              <Box sx={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: 1, zIndex: 10, pb: 0.5 }} onContextMenu={handleImageNavContextMenu}>
                {renderImageNavButtons()}
              </Box>
            )}
          </Box>
          {(cardSettings.showProductName || cardSettings.showSku || cardSettings.showPrice || cardSettings.showStockStatus || cardSettings.showAddToCartButton) && (
              <CardContent sx={{ p: 1, borderTop: '1px solid', borderColor: 'divider', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                  {cardSettings.showProductName && <Typography onContextMenu={(e) => handleContextMenu(e, 'productName')} sx={{ ...elementStyles.productName, cursor: 'context-menu', '&:hover': { textDecoration: 'underline' }, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: 1.5 }}>{displayProduct.name}</Typography>}
                  {cardSettings.showSku && <Typography onContextMenu={(e) => handleContextMenu(e, 'sku')} variant="body2" color="text.secondary" sx={{ ...elementStyles.sku, cursor: 'context-menu' }}>{`SKU: ${displayProduct.stockCode}`}</Typography>}
                  {(cardSettings.showPrice || cardSettings.showStockStatus) && (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: cardSettings.showPrice && cardSettings.showStockStatus ? 'space-between' : 'flex-start' }}>
                      {cardSettings.showPrice && <Typography onContextMenu={(e) => handleContextMenu(e, 'price')} variant="h6" component="div" sx={{ ...elementStyles.price, cursor: 'context-menu' }}>{`${(displayProduct.salePrice || 0).toLocaleString('tr-TR')} ${displayProduct.saleCurrency}`}</Typography>}
                      {cardSettings.showStockStatus && <Box onContextMenu={(e) => handleContextMenu(e, 'stockStatus')} sx={{ cursor: 'context-menu' }}><Chip label={(displayProduct.quantity || 0) > 0 ? "Stokta" : "Tükendi"} color={(displayProduct.quantity || 0) > 0 ? "success" : "error"} size="small" variant="outlined" sx={{ ...elementStyles.stockStatus, height: 'auto', borderRadius: 1, '& .MuiChip-label': { py: '2px', px: '8px' } }} /></Box>}
                    </Box>
                  )}
                </Box>
                {cardSettings.showAddToCartButton && <Button onContextMenu={(e) => handleContextMenu(e, 'addToCartButton')} variant="contained" fullWidth sx={{ mt: 1, backgroundColor: elementStyles.addToCartButton?.backgroundColor || '#0f172a', color: elementStyles.addToCartButton?.color || '#f8fafc', '&:hover': { backgroundColor: elementStyles.addToCartButton?.hoverBackgroundColor || '#1e293b' }, '&:disabled': { backgroundColor: '#64748b', color: '#f1f5f9' }, cursor: 'context-menu' }} startIcon={<ShoppingCart />} disabled={(displayProduct.quantity || 0) === 0}>Sepete Ekle</Button>}
              </CardContent>
          )}
        </Card>
      </Resizable>
      <Menu open={contextMenu !== null} onClose={handleCloseContextMenu} anchorReference="anchorPosition" anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}>
        <MenuItem onClick={handleEditClick}>Özelleştir</MenuItem>
      </Menu>
      <Menu open={imageNavContextMenu !== null} onClose={handleCloseImageNavContextMenu} anchorReference="anchorPosition" anchorPosition={imageNavContextMenu !== null ? { top: imageNavContextMenu.mouseY, left: imageNavContextMenu.mouseX } : undefined}>
        <MenuItem onClick={handleImageNavEditClick}>Düzenle</MenuItem>
      </Menu>
      <Dialog open={isImageNavModalOpen} onClose={() => setIsImageNavModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Resim Geçiş Buton Stili</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <RadioGroup value={imageNavigationStyle} onChange={(e) => setImageNavigationStyle(e.target.value as ImageNavigationStyle)}>
              <FormControlLabel value="numbered" control={<Radio />} label="Numaralı" />
              <FormControlLabel value="circle" control={<Radio />} label="Yuvarlak" />
              <FormControlLabel value="dot" control={<Radio />} label="Nokta" />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsImageNavModalOpen(false)}>İptal</Button>
          <Button 
            onClick={() => {
              setIsImageNavModalOpen(false);
              // Resim geçiş stili değişikliğini kaydet
              if (onSizeChange) {
                console.log('🎨 [PREVIEW] Resim geçiş stili değişti, kayıt tetikleniyor...');
                setTimeout(() => onSizeChange(), 100);
              }
            }} 
            variant="contained"
          >
            Kaydet
          </Button>
        </DialogActions>
      </Dialog>
      {editingElementKey && <ElementStyleEditorModal open={isModalOpen} onClose={() => setIsModalOpen(false)} elementKey={editingElementKey} currentStyles={elementStyles[editingElementKey]} onSave={handleStyleSave} />}
    </Box>
  );
};

export default InteractiveProductCardPreview;